import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import withStyles from "@material-ui/core/styles/withStyles";
import { CheckActionPermission } from "Actions/commonAction";
import TextField from "@material-ui/core/TextField";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../Actions/AxiosInstance";

class ExpenseFuel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      petroldistance: {
        subscriptionfuelpolicyid: 0,
        fueltypeid: 1,
        fueltypename: "Petrol",
        fuelconsumptionid: 1,
        fuelconsumptionname: "Distance",
        fuelvalue: null,
      },
      diseldistance: {
        subscriptionfuelpolicyid: 0,
        fueltypeid: 2,
        fueltypename: "Diesel",
        fuelconsumptionid: 1,
        fuelconsumptionname: "Distance",
        fuelvalue: null,
      },
      electdistance: {
        subscriptionfuelpolicyid: 0,
        fueltypeid: 3,
        fueltypename: "Electricity",
        fuelconsumptionid: 1,
        fuelconsumptionname: "Distance",
        fuelvalue: null,
      },
      gasdistance: {
        subscriptionfuelpolicyid: 0,
        fueltypeid: 4,
        fueltypename: "Natural Gas (CNG)",
        fuelconsumptionid: 1,
        fuelconsumptionname: "Distance",
        fuelvalue: null,
      },
      petrolvolume: {
        subscriptionfuelpolicyid: 0,
        fueltypeid: 1,
        fueltypename: "Petrol",
        fuelconsumptionid: 2,
        fuelconsumptionname: "Volume",
        fuelvalue: null,
      },
      diselvolume: {
        subscriptionfuelpolicyid: 0,
        fueltypeid: 2,
        fueltypename: "Diesel",
        fuelconsumptionid: 2,
        fuelconsumptionname: "Volume",
        fuelvalue: null,
      },
      electvolume: {
        subscriptionfuelpolicyid: 0,
        fueltypeid: 3,
        fueltypename: "Electricity",
        fuelconsumptionid: 2,
        fuelconsumptionname: "Volume",
        fuelvalue: null,
      },
      gasvolume: {
        subscriptionfuelpolicyid: 0,
        fueltypeid: 4,
        fueltypename: "Natural Gas (CNG)",
        fuelconsumptionid: 2,
        fuelconsumptionname: "Volume",
        fuelvalue: null,
      },
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("expenseFuel");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getFuelData();
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getFuelData() {
    instance
      .get("expense/fuelpolicy")
      .then((result) => {
        const petroldistance =
          result.data.result.find(
            (data) => data.fueltypeid == 1 && data.fuelconsumptionid == 1,
          ) || this.state.petroldistance;
        const diseldistance =
          result.data.result.find(
            (data) => data.fueltypeid == 2 && data.fuelconsumptionid == 1,
          ) || this.state.diseldistance;
        const electdistance =
          result.data.result.find(
            (data) => data.fueltypeid == 3 && data.fuelconsumptionid == 1,
          ) || this.state.electdistance;
        const gasdistance =
          result.data.result.find(
            (data) => data.fueltypeid == 4 && data.fuelconsumptionid == 1,
          ) || this.state.gasdistance;
        const petrolvolume =
          result.data.result.find(
            (data) => data.fueltypeid == 1 && data.fuelconsumptionid == 2,
          ) || this.state.petrolvolume;
        const diselvolume =
          result.data.result.find(
            (data) => data.fueltypeid == 2 && data.fuelconsumptionid == 2,
          ) || this.state.diselvolume;
        const electvolume =
          result.data.result.find(
            (data) => data.fueltypeid == 3 && data.fuelconsumptionid == 2,
          ) || this.state.electvolume;
        const gasvolume =
          result.data.result.find(
            (data) => data.fueltypeid == 4 && data.fuelconsumptionid == 2,
          ) || this.state.gasvolume;
        this.setState({
          petroldistance,
          diseldistance,
          electdistance,
          gasdistance,
          petrolvolume,
          diselvolume,
          electvolume,
          gasvolume,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  handleChange(consumptionid, fueltypeid, value) {
    if (consumptionid == 1) {
      if (fueltypeid == 1) {
        if (parseInt(value) < 0) {
          this.setState({
            petroldistance: { ...this.state.petroldistance, fuelvalue: "" },
          });
        } else {
          console.log(
            "this.state.petroldistance before: ",
            this.state.petroldistance,
          );
          this.setState(
            {
              petroldistance: {
                ...this.state.petroldistance,
                fuelvalue: value,
              },
            },
            () => {
              console.log(
                "this.state.petroldistance: ",
                this.state.petroldistance,
              );
            },
          );
        }
      } else if (fueltypeid == 2) {
        if (parseInt(value) < 0) {
          this.setState({
            diseldistance: { ...this.state.diseldistance, fuelvalue: "" },
          });
        } else {
          this.setState({
            diseldistance: { ...this.state.diseldistance, fuelvalue: value },
          });
        }
      } else if (fueltypeid == 3) {
        if (parseInt(value) < 0) {
          this.setState({
            electdistance: { ...this.state.electdistance, fuelvalue: "" },
          });
        } else {
          this.setState({
            electdistance: { ...this.state.electdistance, fuelvalue: value },
          });
        }
      } else if (fueltypeid == 4) {
        if (parseInt(value) < 0) {
          this.setState({
            gasdistance: { ...this.state.gasdistance, fuelvalue: "" },
          });
        } else {
          this.setState({
            gasdistance: { ...this.state.gasdistance, fuelvalue: value },
          });
        }
      }
    } else if (consumptionid == 2) {
      if (fueltypeid == 1) {
        if (parseInt(value) < 0) {
          this.setState({
            petrolvolume: { ...this.state.petrolvolume, fuelvalue: "" },
          });
        } else {
          this.setState({
            petrolvolume: { ...this.state.petrolvolume, fuelvalue: value },
          });
        }
      } else if (fueltypeid == 2) {
        if (parseInt(value) < 0) {
          this.setState({
            diselvolume: { ...this.state.diselvolume, fuelvalue: "" },
          });
        } else {
          this.setState({
            diselvolume: { ...this.state.diselvolume, fuelvalue: value },
          });
        }
      } else if (fueltypeid == 3) {
        if (parseInt(value) < 0) {
          this.setState({
            electvolume: { ...this.state.electvolume, fuelvalue: "" },
          });
        } else {
          this.setState({
            electvolume: { ...this.state.electvolume, fuelvalue: value },
          });
        }
      } else if (fueltypeid == 4) {
        if (parseInt(value) < 0) {
          this.setState({
            gasvolume: { ...this.state.gasvolume, fuelvalue: "" },
          });
        } else {
          this.setState({
            gasvolume: { ...this.state.gasvolume, fuelvalue: value },
          });
        }
      }
    }
  }

  onSave() {
    if (
      this.state.petroldistance.fuelvalue == null ||
      this.state.diseldistance.fuelvalue == null ||
      this.state.electdistance.fuelvalue == null ||
      this.state.gasdistance.fuelvalue == null ||
      this.state.petrolvolume.fuelvalue == null ||
      this.state.diselvolume.fuelvalue == null ||
      this.state.electvolume.fuelvalue == null ||
      this.state.gasvolume.fuelvalue == null
    ) {
      this.props.enqueueSnackbar("Please fill required fields", {
        variant: "error",
      });
    } else {
      const data = {
        fuelpolicy: [
          this.state.petroldistance,
          this.state.diseldistance,
          this.state.electdistance,
          this.state.gasdistance,
          this.state.petrolvolume,
          this.state.diselvolume,
          this.state.electvolume,
          this.state.gasvolume,
        ],
      };

      data.fuelpolicy = data.fuelpolicy.map((fuel) => {
        delete fuel.fueltypename;
        delete fuel.fuelconsumptionname;
        return fuel;
      });
      const URL = `expense/fuelpolicy`;
      instance
        .post(URL, data)
        .then(() => {
          this.props.enqueueSnackbar("Saved Successfully", {
            variant: "success",
          });
          this.getFuelData();
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  render() {
    return (
      <div className="content-outer-wrapper">
        <Helmet>
          <title>{headersList.Config.Fuel_DistanceUnits.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <Grid container className="expense-outer">
            <Grid item xs={12} md={12} sm={12}>
              <div>
                <span className="page-header-name">Fuel Configuration</span>
              </div>
              <div className="margin-bottom-24">
                <span className="normal-dark">
                  🎩🐰 sumHR automates calculation of all fuel related expenses
                  for hassle-free expense claims.{" "}
                </span>
              </div>
            </Grid>
            <Grid item xs={12} md={12} sm={12}>
              <Grid container>
                <Grid item xs={12} md={3} sm={3}>
                  <div>
                    <div
                      className="small-dark"
                      style={{ padding: "10px 0px" }}
                    ></div>
                    <div
                      className="small-dark-secondary"
                      style={{ padding: "15px 0px" }}
                    >
                      Petrol
                    </div>
                    <div
                      className="small-dark-secondary"
                      style={{ padding: "15px 0px" }}
                    >
                      Diesel
                    </div>
                    <div
                      className="small-dark-secondary"
                      style={{ padding: "15px 0px" }}
                    >
                      Electric-Vehicle
                    </div>
                    <div
                      className="small-dark-secondary"
                      style={{ padding: "15px 0px" }}
                    >
                      CNG
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={4} sm={4}>
                  <div>
                    <div className="small-dark-secondary t-bold">
                      Distance rate (per km)
                    </div>
                    <div style={{ margin: "8px 0px" }}>
                      <TextField
                        className="expense-cycle-input"
                        margin="dense"
                        variant="outlined"
                        placeholder={this.props.SubscriptionData.currencycode}
                        InputProps={{
                          inputProps: {
                            min: 1,
                          },
                        }}
                        disabled={
                          this.state.permissions &&
                          !this.state.permissions.editable
                        }
                        onChange={(e) =>
                          this.handleChange(1, 1, e.target.value)
                        }
                        value={
                          this.state.petroldistance &&
                          this.state.petroldistance.fuelvalue
                        }
                        type="number"
                      />
                    </div>
                    <div style={{ margin: "8px 0px" }}>
                      <TextField
                        className="expense-cycle-input"
                        margin="dense"
                        variant="outlined"
                        placeholder={this.props.SubscriptionData.currencycode}
                        InputProps={{
                          inputProps: {
                            min: 1,
                          },
                        }}
                        onChange={(e) =>
                          this.handleChange(1, 2, e.target.value)
                        }
                        disabled={
                          this.state.permissions &&
                          !this.state.permissions.editable
                        }
                        value={
                          this.state.diseldistance &&
                          this.state.diseldistance.fuelvalue
                        }
                        type="number"
                      />
                    </div>
                    <div style={{ margin: "8px 0px" }}>
                      <TextField
                        className="expense-cycle-input"
                        margin="dense"
                        variant="outlined"
                        placeholder={this.props.SubscriptionData.currencycode}
                        InputProps={{
                          inputProps: {
                            min: 1,
                          },
                        }}
                        onChange={(e) =>
                          this.handleChange(1, 3, e.target.value)
                        }
                        disabled={
                          this.state.permissions &&
                          !this.state.permissions.editable
                        }
                        value={
                          this.state.electdistance &&
                          this.state.electdistance.fuelvalue
                        }
                        type="number"
                      />
                    </div>
                    <div style={{ margin: "8px 0px" }}>
                      <TextField
                        className="expense-cycle-input"
                        margin="dense"
                        variant="outlined"
                        placeholder={this.props.SubscriptionData.currencycode}
                        disabled={
                          this.state.permissions &&
                          !this.state.permissions.editable
                        }
                        InputProps={{
                          inputProps: {
                            min: 1,
                          },
                        }}
                        onChange={(e) =>
                          this.handleChange(1, 4, e.target.value)
                        }
                        value={
                          this.state.gasdistance &&
                          this.state.gasdistance.fuelvalue
                        }
                        type="number"
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={5} sm={5}>
                  <div>
                    <div className="small-dark-secondary t-bold">Fuel rate</div>
                    <div style={{ margin: "8px 0px" }}>
                      <span className="margin-right-8">
                        <TextField
                          className="expense-cycle-input"
                          margin="dense"
                          variant="outlined"
                          placeholder={this.props.SubscriptionData.currencycode}
                          disabled={
                            this.state.permissions &&
                            !this.state.permissions.editable
                          }
                          InputProps={{
                            inputProps: {
                              min: 1,
                            },
                          }}
                          onChange={(e) =>
                            this.handleChange(2, 1, e.target.value)
                          }
                          value={
                            this.state.petrolvolume &&
                            this.state.petrolvolume.fuelvalue
                          }
                          type="number"
                        />
                      </span>
                      <span style={{ marginTop: 3 }}>
                        {this.props.SubscriptionData.currencycode} per Liter
                      </span>
                    </div>
                    <div style={{ margin: "8px 0px" }}>
                      <span className="margin-right-8">
                        <TextField
                          className="expense-cycle-input"
                          margin="dense"
                          variant="outlined"
                          placeholder={this.props.SubscriptionData.currencycode}
                          disabled={
                            this.state.permissions &&
                            !this.state.permissions.editable
                          }
                          InputProps={{
                            inputProps: {
                              min: 1,
                            },
                          }}
                          onChange={(e) =>
                            this.handleChange(2, 2, e.target.value)
                          }
                          value={
                            this.state.diselvolume &&
                            this.state.diselvolume.fuelvalue
                          }
                          type="number"
                        />
                      </span>
                      <span style={{ marginTop: 3 }}>
                        {this.props.SubscriptionData.currencycode} per Liter
                      </span>
                    </div>
                    <div style={{ margin: "8px 0px" }}>
                      <span className="margin-right-8">
                        <TextField
                          className="expense-cycle-input"
                          margin="dense"
                          variant="outlined"
                          disabled={
                            this.state.permissions &&
                            !this.state.permissions.editable
                          }
                          placeholder={this.props.SubscriptionData.currencycode}
                          InputProps={{
                            inputProps: {
                              min: 1,
                            },
                          }}
                          onChange={(e) =>
                            this.handleChange(2, 3, e.target.value)
                          }
                          value={
                            this.state.electvolume &&
                            this.state.electvolume.fuelvalue
                          }
                          type="number"
                        />
                      </span>
                      <span style={{ marginTop: 3 }}>
                        {this.props.SubscriptionData.currencycode} per kWh
                      </span>
                    </div>
                    <div style={{ margin: "8px 0px" }}>
                      <span className="margin-right-8">
                        <TextField
                          className="expense-cycle-input"
                          margin="dense"
                          variant="outlined"
                          placeholder={this.props.SubscriptionData.currencycode}
                          disabled={
                            this.state.permissions &&
                            !this.state.permissions.editable
                          }
                          InputProps={{
                            inputProps: {
                              min: 1,
                            },
                          }}
                          onChange={(e) =>
                            this.handleChange(2, 4, e.target.value)
                          }
                          value={
                            this.state.gasvolume &&
                            this.state.gasvolume.fuelvalue
                          }
                          type="number"
                        />
                      </span>
                      <span style={{ marginTop: 3 }}>
                        {this.props.SubscriptionData.currencycode} per KG
                      </span>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            {this.state.permissions && this.state.permissions.editable && (
              <Grid item xs={12} md={12} sm={12}>
                <Button
                  className="margin-top-20"
                  style={{ width: 140 }}
                  color="primary"
                  variant="contained"
                  onClick={this.onSave}
                >
                  Save
                </Button>
              </Grid>
            )}
          </Grid>
        )}
      </div>
    );
  }
}

ExpenseFuel.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles()(withSnackbar(ExpenseFuel)));
